import styled, { css } from 'styled-components';
import Text from '@components/text';
import Image from '@components/image';
import Section from '@components/section';
import { defaultTheme } from '@styles/theme.styled';

export const MessageContainer = styled.div<{ align?: string }>`
  ${({ theme, align }) => css`
    width: 100%;
    max-width: 32rem;
    height: 100%;
    text-align: ${align};
    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
    }
  `}
`;

export const ImageContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    overflow: hidden;
    z-index: 1;
    align-self: stretch;

    width: 100%;
    max-height: 24rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      margin: 0 auto;
      max-width: 100%;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      max-height: 14rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      max-height: 12rem;
      img {
        object-position: center center;
      }
    }
  `}
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

export const ItemIcon = styled(Image)``;

export const StyledSection = styled(Section)<{ condensedSection?: boolean }>`
  width: 100%;
  ${({ theme, condensedSection }) =>
    condensedSection &&
    css`
      padding: 2.5rem 0;

      @media only screen and (max-width: ${theme.breakpoints.xl}) {
        padding: 2rem 0;
      }

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        padding: 1.75rem 0;
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        padding: 1.625rem 0;
      }

      @media only screen and (max-width: ${theme.breakpoints.sm}) {
        padding: 1.5rem 0;
      }
    `}
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const Container = styled.div<{
  enclosureColor?: keyof typeof defaultTheme.backgroundColors;
}>`
  ${({ theme, enclosureColor }) => css`
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    padding: ${enclosureColor === 'dark' ? '0 0' : '6rem 4rem'};
    background-color: ${enclosureColor
      ? theme.backgroundColors[enclosureColor]
      : theme.backgroundColors.white};
    border-radius: ${theme.borderRadius.large};

    ${ImageContainer} {
      max-height: ${enclosureColor === 'dark' ? 'unset' : '24rem'};

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        gap: 3rem;
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        max-height: ${enclosureColor === 'dark' ? 'unset' : '14rem'};
        gap: 2rem;
      }

      @media only screen and (max-width: ${theme.breakpoints.sm}) {
        max-height: ${enclosureColor === 'dark' ? 'unset' : '12rem'};
        img {
          object-position: center center;
        }
      }
    }

    ${MessageContainer} {
      padding: ${enclosureColor === 'dark' ? '4rem 3rem' : '0 '};

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        padding: ${enclosureColor === 'dark' ? '3rem 2rem' : '0 '};
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        padding: ${enclosureColor === 'dark' ? '2rem 3rem' : '0 '};
      }

      @media only screen and (max-width: ${theme.breakpoints.sm}) {
        padding: ${enclosureColor === 'dark' ? '1.5rem 1rem' : '0 '};
      }
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: ${enclosureColor === 'dark' ? '0 0' : '5rem 4rem'};
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: ${enclosureColor === 'dark' ? '0 0' : '4rem 3rem'};
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: ${enclosureColor === 'dark' ? '0 0' : '3rem 4rem'};

      flex-direction: column;
      gap: 2rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: ${enclosureColor === 'dark' ? '0 0' : '2em 1rem'};
      gap: 1.5rem;
      flex-direction: column-reverse;
      align-items: flex-start;
      text-align: left;
      row-gap: 2rem;
    }
  `}
`;

export const BackgroundImageContainer = styled.div`
  ${({ theme }) => css`
    right: 0;
    width: 100%;
    position: absolute;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const Title = styled(Text)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      order: 2;
    }
  `}
`;
